"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const i18next_1 = __importDefault(require("i18next"));
const api_1 = require("@/api");
const functions_1 = require("@/common/functions");
const string_utils_1 = require("@/common/string_utils");
const errors_1 = require("@/common/errors");
function default_1({ isLoggedIn = true, setPending = () => { }, channelId, onSubsChanged, channelName, isToastMessageBottom, }) {
    return __awaiter(this, void 0, void 0, function* () {
        (0, functions_1.tempDisableClick)(500);
        if (isLoggedIn) {
            setPending(true);
            yield (0, api_1.postData)(`/api/v1/profile/${channelId}/subscribe`, null)
                .then(res => {
                var _a, _b;
                const subscribed = ((_b = (_a = res.data) === null || _a === void 0 ? void 0 : _a.meta) === null || _b === void 0 ? void 0 : _b.alert_type) === 20001;
                onSubsChanged(subscribed);
                !!channelName &&
                    (0, functions_1.showToastMessage)({
                        message: i18next_1.default.t(subscribed ? 'channelName님을 구독했어요' : 'channelName님을 구독 취소했어요', { channelName }),
                        isBottom: isToastMessageBottom,
                    });
            })
                .catch(err => {
                var _a, _b, _c;
                if (err.response.status === 403) {
                    window.location.replace((0, string_utils_1.loginReturnPath)());
                }
                else {
                    alert(((_c = (_b = (_a = err.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.result) === null || _c === void 0 ? void 0 : _c.detail) || (0, errors_1.commonErrorMsg)());
                }
            })
                .finally(() => setPending(false));
        }
        else {
            (0, functions_1.showToastMessage)({
                message: i18next_1.default.t('구독은 로그인 후 이용할 수 있어요!'),
                isBottom: isToastMessageBottom,
                toastAnchor: { href: (0, string_utils_1.loginReturnPath)(), text: i18next_1.default.t('로그인하기') },
            });
        }
    });
}
exports.default = default_1;
